import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { BaseUrl } from "../../BaseUrl/BaseUrl";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Mylogo from "../../assets/images/new/newLogo.jpg";
import dayjs from "dayjs";
import { QRCodeSVG } from 'qrcode.react';
import LazySection from "../../Pages/Home/LazySection";
import DeliveryTracker from "../DeliveryTracker/DeliveryTracker";
import { GetOrderTrackingDetails } from "../../ApiServices/BookingTrack/BookingTrackApi";
import { LoaderContext } from "../../AuthContext/AuthContext";
import { GetTempleDarshanBookingDetails } from "../../ApiServices/Temple Darshan Booking/TempleDarshanBookingApi";
import { t } from "i18next";
const DarshanBookingOrderDetails = () => {
  const userID = JSON.parse(localStorage.getItem("userID"));
  const { setLoader, formatToIndianCurrency } = useContext(LoaderContext);
  const [localData, setLocalData] = useState(null);
  const [darshanBokingOrderDetails, setDarshanBokingOrderDetails] = useState({});
  const [orders, setOrders] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const [OrderTrackingDetails, setOrderTrackingDetails] = useState(null)
  const RazorPayKey = process.env.RazorPayKey;
  const RazorPaySecretKey = process.env.RazorPaySecretKey;
  const RazorPayName = process.env.RazorPayName;

  const handleProceedRemainingPayment = async () => {
    if (location.state.TRB_TOTALPRICE - location.state.TRANSACTION_AMT === 0) {
      alert("All the amount already paid");
      return;
    }
    // let totalAmount = parseInt(modelRequestData.totalVal); // Assuming totalVal includes shipping
    // let minPayableAmount = Remaining_Amount; // 20% of the total amount

    let orderIDReturned = location.state.TRB_ID;
    const finalAmount = Number(location.state.TRB_TOTALPRICE);
    const remainingAmount = location?.state?.RemainingAmount;
    const options = {
      key: RazorPayKey,
      key_secret: RazorPaySecretKey,
      amount: remainingAmount * 100,
      currency: "INR",
      name: RazorPayName,
      description: "working",
      image: Mylogo,
      handler: function (response) {

        const paymentId = response.razorpay_payment_id;

        if (response) {
          axios
            .post(`${BaseUrl}/UpdatePaymentStatus?TYPE=Darshan`, {
              USER_ID: userID,
              ORDER_ID: orderIDReturned,
              // ORDER_ID: JSON.parse(localStorage.getItem("orderID")),
              TRANSACTION_ID: paymentId,
              PAYMENT_STATUS: "Success",
              TRANSACTION_STATUS: "Success",
              TRANSACTION_AMT: remainingAmount,
              REMAING_AMOUNT: 0,
              PAYMENT_DATE: dayjs().format("YYYY-MM-DD"),
            })
            .then((res) => {
              if (res.data.ResponseMessage === "successfully.") {
                // localStorage.setItem("cartItemCount", "0");
                // window.dispatchEvent(new Event("cartUpdated"));
                // setShowCODModal(false);
                // nextStep();
                navigate("/my-order-darshan-Booking");
              } else {
                alert("Order placement failed, please try again.");
              }
            });
        }

        // const updatedPayload = {
        //   ...razorPayData,
        //   TRANSACTION_ID: paymentId,
        //   TRANSACTION_AMT: minPayableAmount,
        // };

        // axios.post(`${BaseUrl}/BookPooja`, updatedPayload).then((res) => {

        //   if (res.data.ResponseMessage === "Order Success.") {
        //     localStorage.setItem("cartItemCount", "0");
        //     window.dispatchEvent(new Event("cartUpdated"));
        //     navigate("/thank-you");
        //   } else {
        //     alert("Order placement failed, please try again.");
        //   }
        // });
      },
      theme: {
        color: "#ff416c",
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  const myomnamoQRLink = location?.state?.TRB_ID;
  const trbId = location?.state?.TRB_QRCode;

  useEffect(() => {

    // GetOrderTrackingDetailsData()
    GetTempleDarshanBookingDetailsData()

  }, [location])

  const handleDownloadInvoice = () => {
    const pdfUrl = location?.state?.InvoicePDFURL;
    if (pdfUrl) {
      window.open(pdfUrl, "_blank");
    } else {
      console.error("PDF URL is not available");
    }
  };

  const GetOrderTrackingDetailsData = async () => {
    setLoader(true);
    try {
      let response = await GetOrderTrackingDetails(userID, location?.state?.TRB_ID, 'Darshan'); // Replace with actual import/function call
      if (response?.ResponseCode == "0") {
        setLoader(false);

        const list = response?.DATA || [];
        setOrderTrackingDetails(list[0])

      } else {
        console.error("Bad request");
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  }

  const stepMap = [
    { key: "BookingDate", label: "Processed" },
    { key: "ConfirmedDate", label: "Confirmed" },
    { key: "CompletedDate", label: "Completed" },
    { key: "CancelledDate", label: "Cancelled" },
    { key: "RejectedDate", label: "Rejected" }
  ];

  const GetTempleDarshanBookingDetailsData = async () => {

    setLoader(true);
    try {
      const response = await GetTempleDarshanBookingDetails(location?.state?.order?.darshanBookingKeyID);

      if (response?.statusCode === 200) {
        const list = response?.responseData?.data;

        setDarshanBokingOrderDetails(list[0]);
        // setTotalRecords(list?.length);
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  return (
    <>
      <div className="m-5 p-5 my-4">
        <div className="row">
          {/* Left Section: Multiple Order Items */}
          <div className="col-md-8">
            <div className="card p-3 mb-3 shadow-sm">
              <div className="d-flex align-items-center">
                {/* Product Image on the Left */}
                <img
                  src={darshanBokingOrderDetails?.templeImageURL}
                  alt="Product"
                  className="rounded"
                  style={{
                    width: "180px",
                    height: "150px",
                    objectFit: "contain",
                  }}
                />

                {/* Product Details in the Center */}
                <div className="flex-grow-1 px-3">
                  <h4 className="fw-bold">{darshanBokingOrderDetails?.templeDarshanName}</h4>
                  <hr />
                  {(darshanBokingOrderDetails.address !== null && darshanBokingOrderDetails.address !== undefined) && (
                    <p className=" mb-1">
                      <span className="fw-bold">{t("Temple Address")} :</span>  {darshanBokingOrderDetails.address}
                    </p>
                  )}

                  <p className=" mb-1">
                    <span className="fw-bold">{t("Booking Date")} :</span>    {darshanBokingOrderDetails?.bookingDate}
                  </p>
                  <p className=" mb-1">
                    <span className="fw-bold"> {t("Booking Time")} :</span>   {darshanBokingOrderDetails?.TTS_NAME}
                  </p>
                  <p className=" mb-1">
                    <span className="fw-bold"> {t("Number Of Seats")} :</span>   {darshanBokingOrderDetails?.noOfSeats}
                    {darshanBokingOrderDetails?.templeDarshanSeatMapping?.length > 0 && (
                      <table className="table table-bordered mt-2">
                        <thead>
                          <tr>
                            <th>{t("Sr.No")}</th>
                            <th>{t("Visitor's Name")}</th>
                            <th>{t("Age")}</th>
                            <th>{t("Gender")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {/* <tr>
                            <td>{1}</td>
                            <td>{templeBookingObj?.personName}</td>
                            <td>{templeBookingObj?.AGE}</td>
                            <td>{templeBookingObj?.GENDERID}</td>
                          </tr> */}
                          {darshanBokingOrderDetails?.templeDarshanSeatMapping?.map((value, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{value?.name}</td>
                              <td>{value?.age}</td>
                              <td>{value?.gender}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}

                  </p>
                </div>

                {/* Price on the Right */}
                {/* <div className="text-end">
                  <h5 className="fw-bold  mb-0">
                    ₹{darshanBokingOrderDetails?.TRB_TOTALPRICE}
                  </h5>
                </div> */}
              </div>

            </div>

            {(OrderTrackingDetails !== null && OrderTrackingDetails !== undefined && OrderTrackingDetails !== '') && (

              <div >
                <LazySection><DeliveryTracker statusData={OrderTrackingDetails} stepMap={stepMap} /></LazySection>
              </div>
            )}
            <div>
              <p style={{ fontSize: "17px", fontWeight: "400" }}>
                {t("When you are at temple, please scan below QR code to complete your darshan.")}
              </p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "30px",
                }}
              >
                {/* <QRCodeSVG value={darshanBokingOrderDetails?.TRB_ID} /> */}
                {darshanBokingOrderDetails?.darshanBookingID ? (
                  <QRCodeSVG value={darshanBokingOrderDetails?.darshanBookingID?.toString()} />
                ) : (
                  <p>{t("Darshan Booking ID is not available.")}</p>
                )}

                {/* <QRCodeCanvas
                  value={`${myomnamoQRLink}`}
                  size={150}
                  bgColor="#ffffff"
                  fgColor="#000000"
                  level="H"
                /> */}
              </div>
            </div>
          </div>

          {/* Right Section: Single Product's Shipping & Price Details */}
          <div className="col-md-4">


            <div className="card p-3 shadow-sm">
              <h4 className="fw-bold">Price Details</h4>
              <hr />
              <div className="d-flex justify-content-between">
                <p className=" fw-bold">{t("Price per person")} (₹) : </p>
                <p >{formatToIndianCurrency(darshanBokingOrderDetails?.darshanPrice)}</p>
              </div>
              {(darshanBokingOrderDetails?.couponCodeAmount !== 0 && darshanBokingOrderDetails?.couponCodeAmount !== null) ? (
                <div className="d-flex justify-content-between">
                  <p className=" fw-bold">
                    {t("Coupon Amount")} (₹) :
                  </p>
                  <p >
                    {formatToIndianCurrency(darshanBokingOrderDetails?.couponCodeAmount)}
                  </p>
                </div>
              ) : (darshanBokingOrderDetails?.walletAmount !== 0 && darshanBokingOrderDetails?.walletAmount !== null) ?
                <div className="d-flex justify-content-between">
                  <p className=" fw-bold">
                    {t("Wallet Amount")} (₹) :
                  </p>
                  <p  >
                    {formatToIndianCurrency(darshanBokingOrderDetails?.walletAmount)}
                  </p>
                </div> : ''}
              <div className="d-flex justify-content-between">
                <p className=" fw-bold">{t("Total Seats")} :</p>
                <p >{darshanBokingOrderDetails?.noOfSeats}</p>
              </div>

              <div className="d-flex justify-content-between">
                <p className="fw-bold"> {t("Convenience Fee")} (₹) : </p>
                <p >
                  {Math.round(Number(darshanBokingOrderDetails?.convenienceFee) + Number(darshanBokingOrderDetails?.convinienceFeeTaxAmount))}
                </p>
              </div>
              <hr></hr>
              {/* <div className="d-flex justify-content-between">
                <p className="fw-bold">Total Amount (₹)</p>
                <p className=" fw-bold">
                  <span>  {Number(darshanBokingOrderDetails?.darshanPrice) * Number(darshanBokingOrderDetails?.noOfSeats) + Number(darshanBokingOrderDetails?.convenienceFee)}</span>
                </p>
              </div> */}
              {/* <div className="d-flex justify-content-between">
                <p className="fw-bold">Tax ({darshanBokingOrderDetails?.Tax_Perc}%)</p>
                <p className=" fw-bold">
                  <span>
                    {darshanBokingOrderDetails?.Tax_Amount}

                  </span>
                </p>
              </div> */}
              <div className="d-flex justify-content-between">
                <p className="fw-bold">{t("Grand Total")} (₹)</p>
                <p >

                  {formatToIndianCurrency(Number(darshanBokingOrderDetails?.totalAmount))}

                </p>
              </div>
            </div>

            {darshanBokingOrderDetails?.RemainingAmount == 0 && (
              <button
                className="careox-btn mt-2"
                onClick={() => handleDownloadInvoice(darshanBokingOrderDetails?.TRB_ID)}
              >
                {t("Download Invoice")}
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DarshanBookingOrderDetails;
